/* eslint-disable react-hooks/exhaustive-deps */
/* 热门车型栏 */
import React, { useRef, useState, useEffect } from 'react'
import fetch from 'lib/decorated-fetch'
import classnames from 'classnames'
import get from 'lodash/get'
import Link from 'next/link'

import Image from 'Components/image'
import Loading from 'Components/loading'

import { getZT } from 'lib/zt-util'
import getUrl from 'lib/url'
import { useAdStat } from 'Components/ad'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { IPopularSeriesAd } from './ad/interface'
import { usePopularSeriesAd, PopularSeriesAd } from './ad/series'

interface ISeriesItem {
  cover_url: string
  outter_name: string
  id: number
  info: {
    series_name: string
    series_id: number
    cover_url: string
    brand_name: string
  }
  car_ids: []
  series_status_tag?: object
}
interface INavList {
  name: string
  param: string
  query: string
}

interface IProps {
  params: string
  setParams: (e: string) => void
}

const ConditionList: INavList[] = [
  {
    name: '热门车型',
    param: '',
    query: 'x-x-x-x-x-x-x-x-x-x-x',
  },
  {
    name: '国产',
    param: '&country=0',
    query: 'x-x-0-x-x-x-x-x-x-x-x',
  },
  {
    name: '德系',
    param: '&country=3',
    query: 'x-x-3-x-x-x-x-x-x-x-x',
  },
  {
    name: '日系',
    param: '&country=1',
    query: 'x-x-1-x-x-x-x-x-x-x-x',
  },
  {
    name: '10-15万',
    param: '&price=10,15',
    query: '10,15-x-x-x-x-x-x-x-x-x-x',
  },
  {
    name: '15-25万',
    param: '&price=15,25',
    query: '15,20-x-x-x-x-x-x-x-x-x-x',
  },
  {
    name: '25-35万',
    param: '&price=25,35',
    query: '25,35-x-x-x-x-x-x-x-x-x-x',
  },
  {
    name: '35万以上',
    param: '&price=35,!1',
    query: '35,!1-x-x-x-x-x-x-x-x-x-x',
  },
]

// 获取统计时的字段
function getType(nav: string, type: string): string {
  return nav.match(new RegExp(type, 'i')) ? nav.split('=')[1] : ''
}

export default function PopularModels({ params, setParams }: IProps) {
  /* 当前navigation页 */
  const [nav, setNav] = useState('')
  /* 每个条件所对应的数据 */
  const [carList, setCarList] = useState<any[]>()
  /* 当前带着广告的全部数据 */
  const [newCarList, setNewCarList] = useState<any>([])

  // 现在是hover时触发加载，使用缓存处理下
  const tempStorage = useRef(new Map())

  useEffect(() => {
    try {
      fetchData()
    } catch {
      // no-op
    }
  }, [nav, params])

  const adData = usePopularSeriesAd()

  /* 获取数据 */
  function fetchData() {
    setCarList([])
    if (tempStorage.current && tempStorage.current.has(nav)) {
      setCarList(tempStorage.current.get(nav))
      return
    }
    if (params === 'energy') {
      fetch(getUrl('motor/brand/v3/new_energy_brand/')).then((res) => {
        setCarList(get(res, 'data', []).slice(3))
      })
    } else {
      fetch(getUrl('motor/brand/m/v1/select/series/'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `offset=0&limit=21&sort=hot${nav}${params}`,
      }).then((res) => {
        const result = get(res, 'data.series', [])
        setCarList(result)
        tempStorage.current.set(nav, result)
      })
    }
  }

  // 更新渲染需要的数据
  useEffect(() => {
    setNewCarList([])
    if (nav === '' && carList?.length && Object.keys(adData).length) {
      const arr = handleReplacePosition(
        [...carList],
        [...Object.values(adData)]
      )
      setNewCarList(arr)
    } else {
      setNewCarList(carList)
    }
  }, [carList, adData])

  /* 渲染选择条件 */
  function renderCondition() {
    return (
      <ul>
        {ConditionList.map((item) => (
          <li
            className={classnames({
              active: nav === item.param,
            })}
            key={item.name}
            onMouseOver={() => {
              setParams('')
              setNav(item.param)
            }}
            onClick={() => {
              sendTeaCommEvent('click_home_series_selector', {
                series_type: getType(nav, 'series_type'),
                price_range: getType(nav, 'price'),
                country_type: getType(nav, 'country'),
              })
              window.location.href = `/auto/library/${item.query}`
            }}
          >
            <span>{item.name}</span>
          </li>
        ))}
        <style jsx>
          {`
            ul {
              margin-bottom: 6px;
              display: flex;
              align-items: center;
            }
            li {
              display: inline-block;
              margin-right: 41px;
              font-weight: 500;
              font-size: 18px;
              height: 36px;
              line-height: 36px;
              transition: font-size 0.3s ease-in-out;
            }
            li:hover {
              cursor: pointer;
            }
            li:last-child {
              margin-right: 0;
            }
            .active {
              font-size: 24px;
              font-weight: bold;
            }
          `}
        </style>
      </ul>
    )
  }

  /* 渲染nav页对应的数据 */
  function renderCarList() {
    if (!newCarList || !newCarList.length) {
      return <Loading />
    }
    const list = [
      newCarList.slice(0, 7),
      newCarList.slice(7, 14),
      newCarList.slice(14, 21),
    ]
    return (
      <div className="list">
        {list.map((item: any[], index: number) => (
          <div className="box clearfix" key={index}>
            {item.map((item: any) => {
              const name =
                item.outter_name ||
                item.series_name ||
                item.info.series_name ||
                item.info.brand_name

              // 非热门车型tab下第一行
              if (nav && index === 0 && !(item as IPopularSeriesAd).idx) {
                return (
                  <FirstRowSeriesItem
                    key={name}
                    nav={nav}
                    data={item as ISeriesItem}
                  />
                )
              }
              // 热门车型，非第二行,车系列表可能附加广告
              if (!nav && index !== 1) {
                if ((item as IPopularSeriesAd).idx) {
                  return (
                    <RowSeriesItemWithAD
                      index={index}
                      key={name}
                      nav={nav}
                      data={item as IPopularSeriesAd}
                      rank={item.idx}
                    />
                  )
                } else if (index === 0 && !(item as IPopularSeriesAd).idx) {
                  return (
                    <FirstRowSeriesItem
                      key={name}
                      nav={nav}
                      data={item as ISeriesItem}
                    />
                  )
                }
              }
              return (
                <div className="fl series model" key={name}>
                  <Link
                    href={`/auto/series?seriesId=${
                      item.id || item.info.series_id
                    }`}
                    as={`/auto/series/${item.id || item.info.series_id}`}
                  >
                    <a
                      target="_blank"
                      title={name}
                      onClick={() => {
                        sendTeaCommEvent('click_home_top_series', {
                          series_type: getType(nav, 'series_type'),
                          price_range: getType(nav, 'price'),
                          country_type: getType(nav, 'country'),
                          car_series_id: item.id || item.info.series_id,
                          car_series_name: item.id || item.info.series_name,
                        })
                      }}
                    >
                      <div className="name-wrapper">
                        <span className="series-name">{name}</span>
                        {item.series_status_tag && (
                          <span className="tag">新</span>
                        )}
                      </div>
                    </a>
                  </Link>
                  <SeriesDetail
                    name={name}
                    carIds={item.car_ids}
                    seriesId={item.id || item.info.series_id}
                  />
                </div>
              )
            })}
          </div>
        ))}
        <style jsx>
          {`
            .model {
              margin: 10px 0;
              padding: 0 3px;
              max-width: 112px;
            }
            .name-wrapper {
              display: flex;
              justify-content: center;
              width: 100%;
              position: relative;
              text-align: center;
              height: 22px;
              line-height: 22px;
            }
            .series-name {
              display: inline-block;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              word-break: break-all;
            }
            .tag {
              position: relative;
              display: inline-block;
              padding: 0 2px;
              height: 14px;
              margin-left: 4px;
              top: 3px;
              line-height: 14px;
              font-size: 10px;
              color: #ffffff;
              border-radius: 2px;
              background-color: #fa5555;
            }
          `}
        </style>
      </div>
    )
  }

  return (
    <div className="models fl">
      {renderCondition()}
      {renderCarList()}
      <style jsx>
        {`
          .models {
            width: 800px;
            height: 297px;
            border-top: 0;
          }
        `}
      </style>
    </div>
  )
}

/* 渲染报价图库参数 */

function SeriesDetail({
  seriesId,
  name,
  carIds,
  onClick,
}: {
  seriesId: number
  name: string
  carIds: string[] | number[]
  onClick?(): void
}) {
  return (
    <div
      onClick={() => {
        onClick && onClick()
      }}
    >
      <ul>
        <li>
          <Link
            href={`/dealer?seriesId=${seriesId}&zt=${getZT(
              'pc_home_top_series'
            )}`}
            as={`/dealer/${seriesId}?zt=${getZT('pc_home_top_series')}`}
          >
            <a
              target="_blank"
              title={name}
              onClick={() => {
                sendTeaCommEvent('click_home_top_series_price', {
                  car_series_id: seriesId,
                })
              }}
            >
              <span className="name line-1">报价</span>
            </a>
          </Link>
        </li>
        <li>
          <Link
            href={`/auto/images/detail?category=wg&seriesId=${seriesId}`}
            as={`/series-${seriesId}/images/wg-x-x-x`}
          >
            <a
              target="_blank"
              title={name}
              onClick={() => {
                sendTeaCommEvent('click_home_top_series_picture', {
                  car_series_id: seriesId,
                })
              }}
            >
              <span className="name line-1">图库</span>
            </a>
          </Link>
        </li>
        <li>
          <Link
            href={`/community?series_id=${seriesId}`}
            as={`/community/${seriesId}`}
          >
            <a
              target="_blank"
              title={name}
              onClick={() => {
                sendTeaCommEvent('click_home_top_series_community', {
                  car_series_id: seriesId,
                })
              }}
            >
              <span className="name line-1">车友圈</span>
            </a>
          </Link>
        </li>
      </ul>
      <style jsx>
        {`
          .name.line-1 {
            color: #969aa9;
          }
          .name.line-1:hover {
            color: #e65800;
          }
          ul {
            height: 18px;
            line-height: 18px;
            font-size: 12px;
            display: flex;
            justify-content: space-around;
            margin: 2px 0 2.5px;
            color: #999999;
          }
          li {
            padding: 0 4px;
            position: relative;
          }
          li:first-child {
            padding-left: 0;
          }

          li:not(:last-child)::after {
            content: '';
            top: 4px;
            right: 0;
            background-color: #cccccc;
            height: calc(100% - 8px);
            width: 1px;
            position: absolute;
          }
        `}
      </style>
    </div>
  )
}

function FirstRowSeriesItem({ nav, data }: { nav: string; data: ISeriesItem }) {
  const name = data.outter_name || data.info.series_name || data.info.brand_name
  const id = data.id || data.info.series_id
  const carIds = data.car_ids
  const cover = data.cover_url || data.info.cover_url
  return (
    <div key={name} className={`series fl`}>
      <Link href={`/auto/series?seriesId=${id}`} as={`/auto/series/${id}`}>
        <a
          target="_blank"
          title={name}
          onClick={() => {
            sendTeaCommEvent('click_home_top_series', {
              series_type: getType(nav, 'series_type'),
              price_range: getType(nav, 'price'),
              country_type: getType(nav, 'country'),
              car_series_id: id,
              car_series_name: name,
            })
          }}
        >
          <Image className="photo" src={cover} />
          <div className="name-wrapper">
            <span className="series-name">{name}</span>
            {data.series_status_tag && <span className="tag">新</span>}
          </div>
        </a>
      </Link>
      <SeriesDetail name={name} carIds={carIds} seriesId={id} />
      <style jsx>
        {`
          .series {
            position: relative;
            width: 112px;
            padding: 10px 3px 7px;
            font-size: 14px;
            text-align: center;
            border: 1px solid transparent;
            border-top: 0;
            border-bottom: 2px solid #fff;
          }
          .series:first-child {
            padding-left: 0;
          }
          .series:last-child {
            margin-right: 0;
            padding-right: 0;
          }
          .series :global(.photo) {
            display: block;
            width: 90px;
            height: 60px;
            background-repeat: no-repeat;
            background-size: 90px 60px;
          }
          .series:hover > .photo {
            transform: scale3d(1.1, 1.1, 1.1);
            transition: transform 0.3s ease;
          }
          .name-wrapper {
            display: flex;
            justify-content: center;
            position: relative;
            text-align: center;
            height: 22px;
            line-height: 22px;
          }
          .series-name {
            color: #1f2129;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            word-break: break-all;
          }
          .series-name:hover {
            color: #e65800;
          }
          .tag {
            position: relative;
            display: inline-block;
            padding: 0 2px;
            height: 14px;
            margin-left: 4px;
            top: 3px;
            line-height: 14px;
            font-size: 10px;
            color: #ffffff;
            border-radius: 2px;
            background-color: #fa5555;
          }
        `}
      </style>
    </div>
  )
}

// 广告item,区分第一行
function RowSeriesItemWithAD({
  nav,
  data,
  index,
  rank,
}: {
  nav: string
  data: IPopularSeriesAd
  index: number
  rank: number
}) {
  // 特指广告
  const name = data?.series_name
  const id = data?.series_id
  const carIds = data?.car_ids
  const cover = data?.cover_url
  const [showAd, setShowAd] = useState(false)
  const track =
    index === 0
      ? {
        send: '',
        show: 'ad_show_hot_series_hover_card',
        click: 'ad_click_hot_series_hover_card',
      }
      : {
        send: '',
        show: '',
        click: 'ad_click_home_text_hover',
      }

  const { ref, handleClick } = useAdStat(track, data, { rank }, 2000)
  function handleMouseEnter() {
    setShowAd(true)
  }
  function handleMouseLeave() {
    setShowAd(false)
  }
  return (
    <div key={name} ref={ref} className={`series fl`}>
      <a
        target="_blank"
        title={name}
        onClick={() => {
          // 第一行
          if (index === 0) {
            sendTeaCommEvent('click_home_top_series', {
              series_type: getType(nav, 'series_type'),
              price_range: getType(nav, 'price'),
              country_type: getType(nav, 'country'),
              car_series_id: id,
              car_series_name: name,
            })
          }
          handleClick()
          setTimeout(() => {
            window.open(`/auto/series/${id}`, '_blank')
          }, 50)
        }}
      >
        {/* 第一行，hover image */}
        {index === 0 ? (
          <>
            <div
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              className="photo-wrapper"
            >
              <Image className="photo" src={cover} />
              <PopularSeriesAd
                onClick={handleClick}
                show={showAd}
                data={data}
                index={index}
              />
            </div>
            <div className="name-wrapper">
              <span className="series-name">{name}</span>
            </div>
          </>
        ) : (
          // 其他hover 车系名字
          <div
            className="name-wrapper"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <span className="series-name">{name}</span>
            <PopularSeriesAd
              onClick={handleClick}
              show={showAd}
              data={data}
              index={index}
            />
          </div>
        )}
      </a>
      <SeriesDetail
        onClick={handleClick}
        name={name}
        carIds={carIds}
        seriesId={id}
      />

      <style jsx>
        {`
          .series {
            position: relative;
            width: 112px;
            padding: 0 9px 7px;
            font-size: 14px;
            text-align: center;
            border-top: 0;
          }
          .photo-wrapper {
            padding-top: 10px;
          }
          .series:first-child {
            padding-left: 0;
          }
          .series:last-child {
            margin-right: 0;
            padding-right: 0;
          }
          .series :global(.photo) {
            display: block;
            width: 90px;
            height: 60px;
            background-repeat: no-repeat;
            background-size: 90px 60px;
          }
          .series:hover > .photo {
            transform: scale3d(1.1, 1.1, 1.1);
            transition: transform 0.3s ease;
          }
          .name-wrapper {
            width: 99px;
            display: flex;
            justify-content: center;
            position: relative;
            text-align: center;
            padding-top: ${index === 0 ? '0' : '10px'};
          }
          .series-name {
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            word-break: break-all;
            height: 22px;
          }
          .tag {
            position: relative;
            display: inline-block;
            padding: 0 2px;
            height: 14px;
            margin-left: 4px;
            top: 3px;
            line-height: 14px;
            font-size: 10px;
            color: #ffffff;
            border-radius: 2px;
            background-color: #e62021;
          }
        `}
      </style>
    </div>
  )
}

function handleReplacePosition(data: any[], adData: IPopularSeriesAd[]) {
  // 全部广告的车系id
  const seriesIdList = [...adData].map((adItem: IPopularSeriesAd) => {
    return adItem.series_id
  })
  // 去重，只保留没有重复的item
  const newDedupArr: any = []
  data.map((item: ISeriesItem) => {
    if (!seriesIdList.includes(item.id)) {
      newDedupArr.push(item)
    }
    return item
  })
  // 按位置插入
  adData.map((adInfo: IPopularSeriesAd) => {
    newDedupArr.splice(adInfo.idx - 1, 0, adInfo)
    return adInfo
  })
  return newDedupArr
}
